import React, { useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';

const { createContext, useReducer } = require('react');

const initialState = {
  appInfo: {
    apiName: '',
    apiVersion: '',
    storageBucketVideoRoot: '',
    storageBucketImageRoot: ''
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'GET': {
      return {
        ...state,
        appInfo: action.payload
      };
    }
    default: {
      return { ...state };
    }
  }
};

const APP_INFO = gql`
  query {
    appInfo {
      apiName
      apiVersion
      storageBucketImageRoot
      storageBucketVideoRoot
    }
  }
`;

const AppInfoContext = createContext({
  ...initialState,
  getInfo: () => Promise.resolve()
});

export const AppInfoProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { loading, error, data, refetch } = useQuery(APP_INFO);

  useEffect(() => {
    if (!loading && !error && data && data.appInfo) {
      dispatch({
        type: 'GET',
        payload: data.appInfo
      });
    }
  }, [loading, error, data]);

  const appInfo = () => {
    refetch();
  };

  return (
    <AppInfoContext.Provider
      value={{
        ...state,
        getInfo: appInfo
      }}
    >
      {children}
    </AppInfoContext.Provider>
  );
};

export default AppInfoContext;
